var _defs, _polygon, _polygon2, _line, _circle, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew326({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8.21 5.54 5.3 10.58 11.12 10.58 8.21 5.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8.21 5.54 11.12 0.51 5.3 0.51 8.21 5.54"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.73,
    y1: 5.54,
    x2: 4.27,
    y2: 5.54
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.19,
    cy: 14.09,
    r: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.19,
    y1: 12.69,
    x2: 8.19,
    y2: 10.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew326);
export default __webpack_public_path__ + "static/media/Symbolpack_New_326.2c586c117714d10c491c28ad6c261acf.svg";
export { ForwardRef as ReactComponent };